
import Vue from 'vue'
import { mixins } from 'cms3-shop-module-ts'

export default Vue.extend({
  mixins: [mixins.UiLink],

  props: {
    /**
     * * URL-адрес, на который указывает ссылка
     */
    href: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * * Тип открытия ссылки
     */
    target: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * * Предоставляет метаданные о ссылке, например 'nofollow' или 'noopener'
     */
    rel: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * * Указывает, должна ли ссылка быть активной, если текущий адрес соответствует адресу ссылки
     */
    exact: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * * Добавлять ли текущий URL к адресу ссылки
     */
    append: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * * Если тру, навигация не оставит записей в истории
     */
    replace: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * * Класс, который будет применяться, когда адрес ссылки не совпадает с текущим адресом
     */
    activeClass: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * * Класс, который применяется, когда адрес ссылки совпадает с текущим адресом
     */
    exactActiveClass: {
      type: String,
      required: false,
      default: ''
    }
  }
})
